import { CHALLENGE_CANCEL_COOLDOWN_MS, CHALLENGE_TTL_MS } from "@mk/shared";

/**
 * "Meydan oku" düğmesinin bekleme süresi.
 *
 * Davetin ömrü kadar sürüyor: davet düşene kadar aynı arkadaşa yenisi
 * gönderilemesin. Oturum boyunca modül düzeyinde duruyor — arkadaşlar ekranından
 * çıkıp geri gelmek bekleme süresini sıfırlamasın diye bileşen durumunda değil.
 * Sayfa yenilenince sıfırlanır; asıl güvence sunucuda, bekleyen davet varken
 * yenisini açmıyor.
 */

/**
 * Sunucudaki davet, isteğin ulaşma süresi kadar daha geç düşüyor. Düğme ondan
 * önce açılırsa tıklama "davetin duruyor" hatasıyla geri döner — küçük bir pay
 * bırakıyoruz.
 */
const MARGIN_MS = 2_000;

/** Arkadaşın kimliği -> beklemenin biteceği an (epoch ms). */
const until = new Map<string, number>();

export function startChallengeCooldown(friendId: string, expiresAt?: number): void {
  until.set(friendId, (expiresAt ?? Date.now() + CHALLENGE_TTL_MS) + MARGIN_MS);
}

/** Gönderen iptal ettiğinde eski 5 dakikalık kilidi tam 10 saniyeyle değiştirir. */
export function startChallengeCancelCooldown(friendId: string, cooldownEndsAt?: number): void {
  until.set(friendId, cooldownEndsAt ?? Date.now() + CHALLENGE_CANCEL_COOLDOWN_MS);
}

export function clearChallengeCooldown(friendId: string): void {
  until.delete(friendId);
}

/** Kalan saniye; bekleme yoksa 0. */
export function challengeCooldownLeft(friendId: string, now: number): number {
  const ends = until.get(friendId);
  if (ends === undefined) return 0;
  if (ends <= now) {
    until.delete(friendId);
    return 0;
  }
  return Math.ceil((ends - now) / 1000);
}

export function hasActiveCooldown(now: number): boolean {
  for (const ends of until.values()) {
    if (ends > now) return true;
  }
  return false;
}
